import React from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import { useAppApi, useAppContext } from "@/App";
import { RenderForm } from "@components/Forms/Render";
import { Awesome } from "@components/Helpers";
import { CommonCard, ListingCard } from "@components/Pages";
import { parseQS, url_reverse } from "@components/Utils";

export default function AccessServer({ screen }) {
    const { t } = useTranslation();
    const params = useParams();
    const props = { screen };
    switch (screen) {
        case "access_test_astrum":
            props.header = t("Доступы к test.dl.astrum.team");
            break;
        case "access_admin":
            props.header = t("Доступы к admindl.vkplay.ru");
            break;
    }
    return params.id ? <Edit {...props} id={params.id} /> : <List {...props} />;
}

const List = ({ header, screen }) => {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse(`api:gamecenter:${screen}:list`));
    const { setDelData } = useAppContext();

    if (!apiData) return;

    const query_string = parseQS();
    const dev_id = query_string.dev_id || "";

    const headerTools = (
        <Link
            to={url_reverse(`admin:gamecenter:${screen}:edit`, { access_id: "add" }, { dev_id })}
            className="btn btn-sm btn-dark"
        >
            <Awesome type="plus-circle" /> {t("Добавить")}
        </Link>
    );

    return (
        <ListingCard header={header} headerTools={headerTools}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>IP</th>
                        <th>{t("Примечание")}</th>
                        <th style={{ width: "6%" }} />
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((o) => {
                        return (
                            <tr key={`object_list${o.id}`}>
                                <td>
                                    <Link
                                        to={url_reverse(
                                            `admin:gamecenter:${screen}:edit`,
                                            { access_id: o.id },
                                            { dev_id }
                                        )}
                                    >
                                        {o.ip}
                                    </Link>
                                </td>
                                <td className="show-wrap-text">{o.comment}</td>
                                <td className="dmg-table-row-tools">
                                    <Awesome
                                        type="trash-o"
                                        color="red"
                                        onClick={() =>
                                            setDelData({
                                                url: url_reverse(
                                                    `api:gamecenter:${screen}:edit`,
                                                    {
                                                        access_id: o.id,
                                                    },
                                                    { dev_id }
                                                ),
                                            })
                                        }
                                    />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </ListingCard>
    );
};

const Edit = ({ header, id, screen }) => {
    const dev_id = parseQS().dev_id || "";
    const { apiData } = useAppApi(url_reverse(`api:gamecenter:${screen}:edit`, { access_id: id }, { dev_id }));

    if (!apiData) return;

    return (
        <CommonCard header={header}>
            <RenderForm backUrl={url_reverse(`admin:gamecenter:${screen}:list`, null, { dev_id })} />
        </CommonCard>
    );
};
